export const getBaseURL = () => {
  const { hostname } = window.location;

  // Use different API endpoints based on production domains

  if (hostname === "chaitest.pm-powerconsulting.com") {
    return "https://chaitest.pm-powerconsulting.com/api";
  }
  if (hostname === "powerguide.ai") {
    return "https://powerguide.ai/api";
  }

  if (hostname === "test.powerguide.ai") {
    return "https://test.powerguide.ai/api";
  }
  // for testing env
  if (hostname === "192.168.16.114") {
    return "http://192.168.16.114/api";
  }

  // Use local API for localhost
  return `http://localhost:7000/api`;
};
export const LINK_TO_UNPUBLISHED_CASELET_IN_PDF = import.meta.env.VITE_BASE_LINK_TO_CASELET_IN_PDF + "/#/unpublishedcaselets";
export const LINK_TO_PUBLISHED_CASELET_IN_PDF = import.meta.env.VITE_BASE_LINK_TO_CASELET_IN_PDF + "/#/caselets";
export const Chat: string = "chat";
export const Chats: string = "chats";
export const Seed: string = "seed";
export const caselet: string = "caselet";
export const unPublishCaselet: string = "unPublishCaselet";
export const caseletView: string = "2";
export const loadNumberOfFiles = 5;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const BaseURL = getBaseURL();
export const LINKEDIN_CLIENT_ID = import.meta.env.VITE_LINKEDIN_CLIENT_ID
export const VITE_LINKEDIN_CALLBACK_URL = import.meta.env.VITE_LINKEDIN_CALLBACK_URL 
export const APP_NAME = "PowerGuide"
// export const BASE_FRONT_END_URL =  import.meta.env.VITE_BASE_LINK
